import { Outlet } from 'react-router-dom'

const PartnersPage = () => {

  return (
    <Outlet />
  )
}

export default PartnersPage
